module.exports = __webpack_public_path__ + "static/media/bvlgari-omnia-green-jade-big.69265955.png";